import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { ExtendGovernmentAllocationSchema } from '@/features/privateCompanies/schemas/extendGovernmentAllocation.schema'
import { useMutation } from '@tanstack/react-query'

type ExtendGovernmentAllocationProps = {
  governmentAllocationId?: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

export const useExtendGovernmentAllocation = ({
  governmentAllocationId,
  onSuccess,
  onError,
}: ExtendGovernmentAllocationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['extendGovernmentAllocation', governmentAllocationId],
    mutationFn: async (form: ExtendGovernmentAllocationSchema) => {
      const payload = {
        government_allocation: {
          ...form,
        },
      }

      return privateAxios.put(`/billing/government_allocations/${governmentAllocationId}/extend`, payload)
    },
    onSuccess,
    onError,
  })
}
